module.exports = __webpack_public_path__ + "img/8biticon.23b52576.jpg";